import { Plus, Search } from "lucide-react";
import { useState } from "react";

import { PageHeader } from "@/components/page-header";
import { QueryErrorCard } from "@/components/query-error-card";
import { TableSkeleton } from "@/components/table-skeleton";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAdminUsers } from "@/lib/api";

import { InviteUserDialog } from "./invite-user-dialog";
import { UserTable } from "./user-table";

export function AdminUsersPage() {
  const usersQuery = useAdminUsers();
  const [search, setSearch] = useState("");
  const [inviteOpen, setInviteOpen] = useState(false);

  const users = usersQuery.data ?? [];
  const filtered = users.filter((u) => {
    const q = search.toLowerCase();
    return (
      u.email.toLowerCase().includes(q) ||
      (u.first_name ?? "").toLowerCase().includes(q) ||
      (u.last_name ?? "").toLowerCase().includes(q)
    );
  });

  return (
    <div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6">
      <PageHeader
        eyebrow="Access"
        title="User management"
        description="Invite J&J teammates, set who can administer the platform, and review each person's account."
        actions={
          <Button onClick={() => setInviteOpen(true)}>
            <Plus className="h-4 w-4" />
            Invite user
          </Button>
        }
      />

      {usersQuery.isLoading ? (
        <TableSkeleton columns={5} />
      ) : usersQuery.isError ? (
        <QueryErrorCard
          message="Could not load users."
          onRetry={() => void usersQuery.refetch()}
          backTo="/home"
        />
      ) : (
        <div className="space-y-4">
          <div className="relative max-w-sm">
            <Search className="text-muted absolute top-1/2 left-3 h-4 w-4 -translate-y-1/2" />
            <Input
              placeholder="Search users..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="pl-10"
            />
          </div>
          <UserTable users={filtered} />
        </div>
      )}

      <InviteUserDialog open={inviteOpen} onOpenChange={setInviteOpen} />
    </div>
  );
}
